import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history'; // I18n Configuration

import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit'; // Import extra I18n data

import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales'; // Rhumb

import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4'; // Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import { startApp } from './actions/AppActions'; // Configure the router

import { Router } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import Routes from './components/Routes'; // @ts-expect-error untyped dependency

import WindowDimensionsProvider from 'ecosystem-marketplace-core/components/providers/WindowDimensionsProvider'; // @ts-expect-error untyped dependency

import MediaQueryStylesProvider from 'ecosystem-marketplace-core/components/layout/MediaQueryStylesProvider'; // @ts-expect-error untyped dependency

import HSAnalyticsProvider from 'ecosystem-marketplace-core/components/tracking/HSAnalyticsProvider';

function getLang() {
  return window.I18N_MANUAL_LANG || 'en';
}

export default class App {
  constructor() {
    this.store = configureStore();
  }

  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nProvider.setLocale({
      locale: getLang(),
      langEnabled: true
    });
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    langAvailable.then(() => {
      this.store.dispatch(startApp());
      this.startRouter();
    }).catch(console.error);
  }

  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl(getLang())
    });
    render( /*#__PURE__*/_jsx(UIApplication, {
      name: "marketplace-unified-public-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          history: historyAdapter(history),
          config: rhumbConfig,
          children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
            children: /*#__PURE__*/_jsx(MediaQueryStylesProvider, {
              children: /*#__PURE__*/_jsx(WindowDimensionsProvider, {
                children: /*#__PURE__*/_jsx(Router, {
                  history: history,
                  children: /*#__PURE__*/_jsx(Routes, {})
                })
              })
            })
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}